import React, { useState } from "react";
import styles from "./spectreEventTable.module.sass";
import cn from "classnames";
import Checkbox from "../../../Checkbox";
import Row from "./Row";

const Table = ({access, items, title }) => {

  const desiredLength = 10;
  items = items.concat(Array(desiredLength - items.length).fill({})).slice(0, desiredLength)

  return (
    <div className={styles.wrapper}>
      <div className={styles.table}>
        <div className={styles.row}>
          <div className={styles.col}>Name</div>
          <div className={styles.col}>Category</div>
          <div className={styles.col}>Parameter</div>
          <div className={styles.col}>Subscribed</div>
          <div className={styles.col}></div>
        </div>
        {items && items.map((x, index) => (
          <Row access={access} item={x} key={index} index={index} />))}
      </div>
    </div>
  );
};

export default Table;
